import React, { memo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import InsightsSectionHeading from "./InsightsSectionHeading";
import InsightsIntensityZonesBar from "./InsightsIntensityZonesBar";

/**
 * “Intensity zones” subsection: heading + segmented bar (per-lift cards).
 */
function InsightsIntensityZonesBlock({ zones, headingInfoKey = "lift" }) {
  const { t } = useTranslation("athlete-portal");

  return (
    <div className="ProgramInsights-intensityZonesBlock">
      <InsightsSectionHeading
        showRule={false}
        title={t("programs.programInsights.panel.sectionIntensityZones")}
        infoAriaLabel={t(
          `programs.programInsights.panel.intensityZonesInfo.${headingInfoKey}`
        )}
      />
      <InsightsIntensityZonesBar zones={zones} />
    </div>
  );
}

InsightsIntensityZonesBlock.propTypes = {
  zones: PropTypes.arrayOf(
    PropTypes.shape({
      zoneId: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    })
  ).isRequired,
  /** Namespace key under intensityZonesInfo for the (?) aria label. */
  headingInfoKey: PropTypes.string,
};

export default memo(InsightsIntensityZonesBlock);
